import { useEffect } from 'react';
import { useAuth, useUserData } from '../../auth';
import { usePermissions } from '../../hooks/usePermissions';
import { useCalendarSharingStore } from '../../stores/calendarSharingStore';

/**
 * Fuori dalla pagina Calendario (modulo di una task, pannello laterale) i calendari condivisi
 * possono non essere ancora caricati: li carica una volta, con gli stessi permessi della pagina.
 */
export function useEnsureSharing(enabled = true) {
  const { user } = useAuth();
  const { organizationId } = useUserData();
  const { hasPermission, loading } = usePermissions();
  const ready = useCalendarSharingStore(s => s.ready);
  const busy = useCalendarSharingStore(s => s.loading);
  const load = useCalendarSharingStore(s => s.load);
  const canSeeAll = hasPermission('calendar_others', 'view');
  const canEditOthers = hasPermission('calendar_others', 'update');
  useEffect(() => {
    if (!enabled || ready || busy || loading || !user?.id || !organizationId) return;
    void load({ meId: user.id, organizationId, canSeeAll, canEditOthers });
  }, [enabled, ready, busy, loading, user?.id, organizationId, canSeeAll, canEditOthers, load]);
}
